import { Button } from "@/components/atoms";
import { FixedFooter } from "../FixedFooter";
import { ButtonContainerStyled } from "./style";
import { Link } from "react-router-dom";

export function ButtonContainer() {
  return (
    <FixedFooter>
      <ButtonContainerStyled>
        <Button isBasic>Fechar</Button>
        <Link to="/modal/formulario">
          <Button isPrimary>Criar ticket</Button>
        </Link>
      </ButtonContainerStyled>
    </FixedFooter>
  );
}